/**
 * Constants for RiseAI Chat component
 */

export const DRAWER_WIDTH = '1200px';

export const CATEGORIES = ['All', 'Vulnerabilities', 'SBOM', 'Licenses', 'Cryptography', 'Binaries', 'Secrets'];

export const RISE_AI_APP_NAME = 'rise_ai_llm_agent';

export const RISE_AI_STATUS = {
  UNSPECIFIED: 'UNSPECIFIED',
  PENDING: 'PENDING',
  PROCESSING: 'PROCESSING',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
  NOT_ELIGIBLE: 'NOT_ELIGIBLE',
  ELIGIBLE: 'ELIGIBLE'
};
